// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>12</span>&nbsp;&nbsp;Arise, O Lord God, and lift up your hand;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;forget not the poor.<br> </p> </div></div>";
// Exports
module.exports = code;